export const REDUCER_PATHS = {
  AUTH: "auth",
  TOKEN: "token",
  USERS: "users",
  MASTER: "master",
  PROFILE: "profile",
  SETTINGS: "settings",
  ROLE: "role",
  EMAIL_TEMPLATES: "emailTemplates",
  BLOG: "blog",
  FILTER: "filter",
  SUPPORT: "support",
  PROPERTY: "property",
  TRANSACTIONS: "transactions",
  DIVIDEND: "dividend",
  SALE_PROCEED: "saleProceed",
  INVESMENTS: "invesments",
  REWARDS: "rewards",
};

export const REDUCER_TAGS = {
  POSTS: "Posts",
  PROFILE: "Profile",
  SETTINGS: "settings",
  USERS: "users",
};
